import React, { useState, useEffect, useCallback } from "react";
import Drawer from "react-modern-drawer";
import useDashboardStore from "../../../../stores/dashboard";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Checkbox from "../../../../components/Checkbox/Index";
import Select from "../../../../components/form/select";

import visa from "../../../../../../images/v2/visa24x24.svg";
import mastercard from "../../../../../../images/v2/master24x24.svg";
import discover from "../../../../../../images/v2/discover24x24.svg";
import amex from "../../../../../../images/v2/amex24x24.svg";
import Button from "../../../../components/new-button";
import useUserStore from "../../../../stores/user";
import { GetOrganizationById, SearchOrganizations } from "../../../../../api";
import "react-modern-drawer/dist/index.css";
import styles from "./styles.module.scss";
const paymentProcessors = [
  { id: 1, name: "Beyond" },
  { id: 2, name: "EMS" },
  { id: 3, name: "IPP" },
  { id: 4, name: "Nexio" },
  { id: 5, name: "Nuvei" },
  { id: 6, name: "Payarc" },
  { id: 7, name: "Payroc" },
  { id: 8, name: "Priority" },
  { id: 9, name: "Signature" },
];

const cards = [
  { id: 1, name: "Visa", icon: visa },
  { id: 2, name: "Mastercard", icon: mastercard },
  { id: 3, name: "Amex", icon: amex },
  { id: 4, name: "Discover", icon: discover },
  { id: 5, name: "Debit" },
  { id: 6, name: "EBT" },
];

const FilterDrawer = () => {
  const filterDrawerOpen = useDashboardStore((state) => state.filterDrawerOpen);
  const setFilterDrawerOpen = useDashboardStore(
    (state) => state.setFilterDrawerOpen,
  );
  const [selectedPaymentProcessors, setSelectedPaymentProcessors] = useState(
    [],
  );
  const [selectedCards, setSelectedCards] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [filterOrgLocal, setFilterOrgLocal] = useState(null);
  const [filterUserLocal, setFilterUserLocal] = useState(null);
  const [goalFilterKeyLocal, setGoalFilterKeyLocal] = useState(null);

  const [users, setUsers] = useState([]);
  const filterUser = useDashboardStore((state) => state.filterUser);
  const setFilterUser = useDashboardStore((state) => state.setFilterUser);
  const filterOrg = useDashboardStore((state) => state.filterOrg);
  const setFilterOrg = useDashboardStore((state) => state.setFilterOrg);
  const setGoalFilterKey = useDashboardStore((state) => state.setGoalFilterKey);

  const [isLoading, setIsLoading] = useState(false);

  const user = useUserStore((state) => state.user);
  const isGodUser = user?.is_pc_admin;
  const isOrgAdmin = user?.role === "admin";

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      if (isGodUser) {
        const res = await SearchOrganizations(null);
        if (!res.success) {
          console.error("There was a problem fetching organizations");
        }

        const orgsOptions = res.data.map((org) => ({
          label: org.name,
          value: org.id,
        }));

        setOrganizations(orgsOptions);
      } else if (isOrgAdmin && user?.organization_id) {
        const res = await GetOrganizationById(user.organization_id);
        if (res.users && res.users.length) {
          const usersOptions = res.users.map((user) => ({
            label: user.name,
            value: user.id,
          }));
          setUsers(usersOptions);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [isGodUser, isOrgAdmin, user?.organization_id]);

  useEffect(() => {
    fetchData();
  }, [isGodUser, isOrgAdmin, user?.organization_id, fetchData]);

  const handleOnSearchInputChange = async (term) => {
    try {
      const res = await SearchOrganizations({ term });
      if (!res.success) {
        console.error("There was a problem fetching organizations");
      }

      const orgsOptions = res?.data.map((org) => ({
        label: org.name,
        value: org.id,
      }));

      setOrganizations(orgsOptions);
    } catch (error) {
      console.error("Error fetching organizations:", error);
    }
  };

  const handleOnOrganizationSelectChange = (selectedOption) => {
    setFilterOrgLocal(selectedOption);
    setGoalFilterKeyLocal(
      selectedOption ? `org-${selectedOption?.value}` : null,
    );
  };

  const handleOnUserSelectChange = (selectedOption) => {
    setFilterUserLocal(selectedOption);
    setGoalFilterKeyLocal(
      selectedOption ? `agent-${selectedOption?.value}` : null,
    );
  };

  return (
    <Drawer
      open={filterDrawerOpen}
      onClose={() => setFilterDrawerOpen(false)}
      direction="right"
      size={"auto"}
      zIndex={999}
      overlayColor={"#000"}
      overlayOpacity={0.5}
    >
      <div className={styles.filterDrawerContainer}>
        <div className={styles.filterDrawerHeader}>
          <ButtonIcon onClick={() => setFilterDrawerOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#A4A3A8"
              />
            </svg>
          </ButtonIcon>
        </div>

        <div className={styles.filterDrawerTitle}>
          <h5>Filter</h5>
        </div>

        <div className={styles.filterContentContainer}>
          {/* Organization/User Filter Section - Only visible to org admins */}
          {(isGodUser || isOrgAdmin) && (
            <div className={styles.statusFilter}>
              <h5 className={styles.heading}>
                {isGodUser ? "ORGANIZATION" : "USER"}
              </h5>
              <div className={styles.filterContainer}>
                {isGodUser ? (
                  <>
                    <Select
                      async
                      search
                      options={organizations}
                      value={filterOrgLocal}
                      onSearchChange={handleOnSearchInputChange}
                      onChange={handleOnOrganizationSelectChange}
                      placeholder="Search organizations"
                    />
                  </>
                ) : (
                  <>
                    <Select
                      options={users}
                      value={filterUserLocal}
                      onChange={handleOnUserSelectChange}
                      placeholder="Search users"
                      search
                    />
                  </>
                )}
              </div>
            </div>
          )}

          <div className={styles.statusFilter}>
            <h5 className={styles.heading}>PAYMENT PROCESSOR</h5>
            <div className={styles.filterList}>
              {paymentProcessors.map((processor) => (
                <label
                  key={`processor-${processor.id}`}
                  className={styles.filterListItem}
                  htmlFor={`processor-${processor.id}`}
                >
                  <Checkbox
                    name={`processor-${processor.id}`}
                    id={`processor-${processor.id}`}
                    value={`processor-${processor.id}`}
                    onChange={() => {
                      if (selectedPaymentProcessors.includes(processor.id)) {
                        setSelectedPaymentProcessors(
                          selectedPaymentProcessors.filter(
                            (id) => id !== processor.id,
                          ),
                        );
                      } else {
                        setSelectedPaymentProcessors([
                          ...selectedPaymentProcessors,
                          processor.id,
                        ]);
                      }
                    }}
                    checked={selectedPaymentProcessors.includes(processor.id)}
                  />

                  <div className={styles.filterListItemLabel}>
                    <span>{processor.name}</span>
                  </div>
                </label>
              ))}
            </div>
          </div>

          <div className={styles.statusFilter}>
            <h5 className={styles.heading}>CARDS</h5>
            <div className={styles.filterList}>
              {cards.map((card) => (
                <label
                  key={`card-${card.id}`}
                  className={styles.filterListItem}
                  htmlFor={`card-${card.id}`}
                >
                  <Checkbox
                    name={`card-${card.id}`}
                    id={`card-${card.id}`}
                    value={`card-${card.id}`}
                    onChange={() => {
                      if (selectedCards.includes(card.id)) {
                        setSelectedCards(
                          selectedCards.filter((id) => id !== card.id),
                        );
                      } else {
                        setSelectedCards([...selectedCards, card.id]);
                      }
                    }}
                    checked={selectedCards.includes(card.id)}
                  />

                  {card.icon && (
                    <div className={styles.filterListItemIcon}>
                      <img src={card.icon} />
                    </div>
                  )}
                  <div className={styles.filterListItemLabel}>
                    <span>{card.name}</span>
                  </div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          variant="secondary"
          size="large"
          onClick={() => {
            setSelectedPaymentProcessors([]);
            setSelectedCards([]);

            setFilterUser("");
            setFilterOrg("");
            setGoalFilterKey("");

            setFilterUserLocal("");
            setFilterOrgLocal("");
            setGoalFilterKeyLocal("");
            // setFilterDrawerOpen(false);
          }}
        >
          Clear
        </Button>
        <Button
          variant="primary"
          size="large"
          onClick={() => {
            setFilterUser(filterUserLocal || "");
            setFilterOrg(filterOrgLocal || "");
            setGoalFilterKey(goalFilterKeyLocal || "");
            setFilterDrawerOpen(false);
          }}
        >
          Apply
        </Button>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
